export const init = () => {
    const stats = document.querySelectorAll('.about-me__stat-number');
    
    if (stats.length === 0) return;

    const animateCount = (el) => {
        const targetAttr = el.getAttribute('data-count');
        const target = parseInt(targetAttr);
        if (isNaN(target)) return;
        
        const duration = 2000;
        const startTime = performance.now();
        
        // Preserve suffix (like + or %)
        const originalText = el.innerText.trim();
        const suffix = originalText.replace(/[0-9]/g, '');
        
        const update = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing (outQuad)
            const easedProgress = progress * (2 - progress);
            
            const current = Math.floor(easedProgress * target);
            el.innerText = current + suffix;
            
            if (progress < 1) {
                requestAnimationFrame(update);
            } else {
                el.innerText = target + suffix;
            }
        };
        
        requestAnimationFrame(update);
    };

    const observerOptions = {
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCount(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    stats.forEach(stat => observer.observe(stat));
};
